export type LoginLegacyRouteEntry = {
  path: string;
  source: string;
};

export const loginLegacyRouteManifest: LoginLegacyRouteEntry[] = [
  { path: '/legacy/auth/access-denied-page', source: 'apps/login/src/pages/AccessDeniedPage.tsx' },
  { path: '/legacy/auth/auth-continue', source: 'apps/login/src/pages/AuthContinue.tsx' },
  { path: '/legacy/auth/auth-continue-page', source: 'apps/login/src/pages/AuthContinuePage.tsx' },
  { path: '/legacy/auth/email-callback-page', source: 'apps/login/src/pages/EmailCallbackPage.tsx' },
  { path: '/legacy/auth/ghost-auth-page', source: 'apps/login/src/pages/GhostAuthPage.tsx' },
  { path: '/legacy/auth/session-expired-page', source: 'apps/login/src/pages/SessionExpiredPage.tsx' },
  { path: '/legacy/auth/tenant-chooser-page', source: 'apps/login/src/pages/TenantChooserPage.tsx' },
];
